/* eslint-disable @typescript-eslint/explicit-function-return-type */
import React from 'react';
import { Banner } from '@everlywell/leaves';
import ewAnalytics from 'utils/analytics';
import { ANALYTICS } from 'utils/constants/analytics';
import * as S from './styles';
import * as BCS from './brand-centric-styles';
import { HomepageHeroProps } from './index';

export const BrandCentricHomepageHero = ({
  headline,
  description,
  mainCta,
  desktopImage,
  mobileImage,
  listOfContent,
  backgroundColor,
  topBanner,
  ...rest
}: HomepageHeroProps) => {
  const handleClick = () => {
    ewAnalytics.track({
      event: ANALYTICS.EVENTS.CLICKED_BUTTON,
      data: {
        label: ANALYTICS.LABELS.HOMEPAGE_HERO_CTA,
      },
    });
  };

  return (
    <>
      {topBanner?.text && topBanner?.link ? (
        <Banner
          text={topBanner.text}
          url={topBanner.link}
          ctaText={topBanner.ctaText}
        />
      ) : null}
      <BCS.Section backgroundColor={'#007377'} {...rest} data-testid="hero">
        <BCS.TextContainer>
          <S.HeadlineAndDescription>
            {headline ? (
              <S.Headline style={{ color: 'white', textAlign: 'center' }}>
                {headline}
              </S.Headline>
            ) : null}
            {description ? (
              <S.Description style={{ color: 'white', textAlign: 'center' }}>
                {description}
              </S.Description>
            ) : null}
          </S.HeadlineAndDescription>
          {mainCta ? (
            <S.MainCTA
              href={mainCta.url}
              appearance="hero"
              onClick={handleClick}
            >
              {mainCta.text}
            </S.MainCTA>
          ) : null}
        </BCS.TextContainer>
        <BCS.MobileImg>
          <BCS.Mailbox
            // @ts-ignore
            fluid={listOfContent[1]?.image.fluid}
            alt="mobile mailbox"
          />
          <BCS.Results
            // @ts-ignore
            fluid={listOfContent[3]?.image.fluid}
            alt="mobile results"
          />
        </BCS.MobileImg>

        <BCS.MailboxWrapper>
          <BCS.Mailbox
            // @ts-ignore
            fluid={listOfContent[0]?.image.fluid}
            alt="desktop mailbox"
          />
        </BCS.MailboxWrapper>
        <BCS.ResultWrapper>
          <BCS.Results
            // @ts-ignore
            fluid={listOfContent[2]?.image.fluid}
            alt="desktop results"
          />
        </BCS.ResultWrapper>
      </BCS.Section>
    </>
  );
};

export default BrandCentricHomepageHero;
